<template>
    <transition name="fade">
        <!-- Modal -->
    <div v-if="show" class="modal" tabindex="-1" >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ title }}</h4>
                </div>
                <div class="modal-body" v-html="body"></div>
                <div class="modal-footer" v-if="showFooter">
                    <button type="button" class="btn btn-default" @click="confirmNo">{{ getTranslation('lbl_no') }}</button>
                    <button type="button" class="btn btn-primary" @click="confirmYes">{{ getTranslation('lbl_yes') }}</button>
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>


<script>
    import { translationMixin } from '../mixins/translationMixin';

    export default {
        mixins: [ translationMixin ],
        props: ['show', 'title', 'body', 'showFooter'],
        data: function(){
            return {
                toShow: this.show
            }
        },
//        computed: {
//            display: function(){
//                console.log('toShow', this.show);
//                if(this.show){
//                    this.toDisplay = 'display:block'
//                } else {
//                    this.toDisplay = 'display:none'
//                }
//                return this.toDisplay;
//            }
//        },
        methods: {
            confirmNo: function(){
                this.$emit('confirmNo');
            },
            confirmYes: function(){
                this.$emit('confirmYes');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// BanetModalConfirm.vue?7713a0c8